import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IHistoryState, ShownTypes } from './types';
import { initialHistoryFields } from '../../../pages/onboardingPageV2/constants/initialHistoryFields';
import { convertNestedToDotNotation } from '../../../pages/onboardingPageV2/helpers/convertObjToHistory';
import { sortFields } from './sortByStartDate';
import { openErrorNotification } from '../../../components/notification/Notification';
import { ITabNames } from '../onboarding/types';

const initialState: IHistoryState = {
    total: {},
    activeFields: {},
    historyFields: {},
    errorMessages: [],
    activeKeys: [],
};

const reducer = createSlice({
    name: 'onboarding-history',
    initialState,
    reducers: {
        setTotalHistory(state, action) {
            state.total = action.payload;
        },
        setActiveFields(state, action) {
            const fields = convertNestedToDotNotation(action.payload) as any;
            state.activeFields = fields;
            // Object.keys(fields).forEach((key: any) => {
            //   if (!fields[key] || !fields[key]?.length) {
            //     state.activeFields[key] = [
            //       // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //       //@ts-ignore
            //       initialHistoryFields[key].reduce((acc: any, element: any) => {
            //         if (element.key === 'isReligious') {
            //           acc[element.key] = action.payload[key]?.[element.key];
            //         } else {
            //           acc[element.key] =
            //             element.inputType === 'number'
            //               ? 0
            //               : element.type === ShownTypes.uploadFile
            //                 ? []
            //                 : element.type === ShownTypes.checkbox ||
            //                   element.type === ShownTypes.switch ||
            //                   element.type === ShownTypes.radio
            //                   ? false
            //                   : '';
            //         }

            //         return acc;
            //       }, {} as Record<string, string | boolean | undefined>),
            //     ];
            //   }
            // });
            Object.keys(fields).forEach((key) => {
                if (!state.historyFields[key]) {
                    state.historyFields[key] = [];
                }
            });
            // sortFields(state);
        },
        setHistoryFields(state, action) {
            const newHistoryFields = convertNestedToDotNotation(action.payload);

            Object.keys(newHistoryFields).forEach((key) => {
                if (!state.historyFields[key]) {
                    state.historyFields[key] = newHistoryFields[key];
                } else {
                    const mergedArray = [...state.historyFields[key], ...newHistoryFields[key]];

                    const uniqueArray = mergedArray.filter(
                        (item, index, self) => !item._id || index === self.findIndex((t) => t._id === item._id)
                    );

                    state.historyFields[key] = uniqueArray;
                }
            });
            // sortFields(state);
        },
        changeActiveField(
            state,
            action: PayloadAction<{
                fieldKey: string;
                index: number;
                value: any;
                changedField: string;
                companyId?: string;
            }>
        ) {
            const { fieldKey, index, value, changedField, companyId } = action.payload;

            if (companyId) {
                const matchingItems = state.activeFields[fieldKey].filter((item: any) => item.companyId === companyId);

                if (matchingItems[index]) {
                    matchingItems[index][changedField] = value;
                }
            } else {
                if (state.activeFields[fieldKey][index]) {
                    state.activeFields[fieldKey][index][changedField] = value;
                }
            }

            // sortFields(state);
        },

        changeHistoryField(
            state,
            action: PayloadAction<{
                fieldKey: string;
                index: number;
                value: any;
                changedField: string;
                companyId?: string;
            }>
        ) {
            const { fieldKey, index, value, changedField, companyId } = action.payload;

            if (companyId) {
                const matchingItems = state.historyFields[fieldKey].filter((item: any) => item.companyId === companyId);

                if (matchingItems[index]) {
                    matchingItems[index][changedField] = value;
                }
            } else {
                if (state.historyFields[fieldKey][index]) {
                    state.historyFields[fieldKey][index][changedField] = value;
                }
            }
            // sortFields(state);
        },

        addNewActiveField(
            state,
            action: PayloadAction<{
                fieldKey: string;
                newField: Record<string, unknown>;
            }>
        ) {
            const { fieldKey, newField } = action.payload;
            //for 2 active field set last field to history
            if (state.activeFields[fieldKey].length > 1) {
                state.historyFields[fieldKey] = [state.activeFields[fieldKey][1], ...state.historyFields[fieldKey]];
                state.total[fieldKey] += 1;
                state.activeFields[fieldKey] = [newField, state.activeFields[fieldKey][0]];
                return;
            }
            state.activeFields[fieldKey] = [newField, ...state.activeFields[fieldKey]];

            // sortFields(state);
        },
        moveToHistory(
            state,
            action: PayloadAction<{
                fieldKey: string;
                index: number;
                newField: Record<string, unknown>;
            }>
        ) {
            const { fieldKey, index, newField } = action.payload;
            const [removed] = state.activeFields[fieldKey].splice(index, 1);
            state.historyFields[fieldKey].unshift(removed);
            state.total[fieldKey] += 1;

            // if (state.activeFields[fieldKey].length === 0) {
            //   state.activeFields[fieldKey].push(newField);
            // }

            // sortFields(state);
        },

        moveToActive(state, action: PayloadAction<{ fieldKey: string; index: number }>) {
            const { fieldKey, index } = action.payload;
            if (!state.historyFields[fieldKey] || !state.historyFields[fieldKey][index]) {
                return;
            }

            const [removed] = state.historyFields[fieldKey].splice(index, 1);

            if (!state.activeFields[fieldKey]) {
                state.activeFields[fieldKey] = [];
            }
            if (state.activeFields[fieldKey].length >= 2) {
                const lastActive = state.activeFields[fieldKey].pop();
                if (lastActive) {
                    state.historyFields[fieldKey].unshift(lastActive);
                }
            }
            state.total[fieldKey] = state.historyFields[fieldKey].length;
            state.activeFields[fieldKey].unshift(removed);

            // sortFields(state);
        },
        removeFromActiveField(
            state,
            action: PayloadAction<{
                fieldKey: string;
                index: number;
                newField: Record<string, unknown>;
            }>
        ) {
            const { fieldKey, index, newField } = action.payload;
            state.activeFields[fieldKey].splice(index, 1);
            // if (state.activeFields[fieldKey].length === 0) {
            //   state.activeFields[fieldKey].push(newField);
            // }
        },
        removeFromHistoryField(
            state,
            action: PayloadAction<{
                fieldKey: string;
                index: number;
            }>
        ) {
            const { fieldKey, index } = action.payload;
            state.historyFields[fieldKey].splice(index, 1);
            state.total[fieldKey] -= 1;
        },
        resetAllFields(state) {
            state.total = {};
            state.activeFields = {};
            state.historyFields = {};
        },
        setHistoryErrorMessages(state, action: PayloadAction<{ messages: any; tabName: string }>) {
            if (Array.isArray(action.payload.messages)) {
                state.errorMessages = action.payload.messages;
                console.log(action.payload);
                if (action.payload?.messages?.length) {
                    openErrorNotification(
                        'One or few mandatory fields are empty. Please fill them out.',
                        action.payload?.tabName
                            ? `Warning alert - ${ITabNames[action.payload?.tabName as keyof typeof ITabNames]}`
                            : ''
                    );
                }
            }
        },
        setAllFields(state, action) {
            const fields = convertNestedToDotNotation(action.payload) as any;

            Object.keys(fields).forEach((key) => {
                const items = fields[key];
                state.activeFields[key] = items.filter((item: any) => item.isActive);
                state.historyFields[key] = items.filter((item: any) => !item.isActive);
            });

            sortFields(state);
        },
        removeActiveFile(
            state,
            action: PayloadAction<{
                fieldKey: string;
                index: number;
                value: any;
                changedField: string;
                companyId?: string;
            }>
        ) {
            const { fieldKey, index, value, changedField } = action.payload;

            const item: any = state.activeFields[fieldKey][index][changedField];
            if (item) {
                const idx = item.findIndex((el: any) => el.originalFilename === value);

                state.activeFields[fieldKey][index][changedField] = [...item.slice(0, idx), ...item.slice(idx + 1)];
            }
        },
        removeHistoryFile(
            state,
            action: PayloadAction<{
                fieldKey: string;
                index: number;
                value: any;
                changedField: string;
                companyId?: string;
            }>
        ) {
            const { fieldKey, index, value, changedField, companyId } = action.payload;

            const item: any = state.historyFields[fieldKey][index][changedField];

            if (item) {
                const idx = item.findIndex((el: any) => el.originalFilename === value);

                state.historyFields[fieldKey][index][changedField] = [...item.slice(0, idx), ...item.slice(idx + 1)];
            }
        },
        setActiveKeys(state, action) {
            state.activeKeys = action.payload;
        },
    },
});

export const {
    setTotalHistory,
    setActiveFields,
    setHistoryFields,
    addNewActiveField,
    moveToActive,
    moveToHistory,
    changeActiveField,
    changeHistoryField,
    removeFromActiveField,
    removeFromHistoryField,
    resetAllFields,
    setHistoryErrorMessages,
    setAllFields,
    removeActiveFile,
    removeHistoryFile,
    setActiveKeys,
} = reducer.actions;

export default reducer.reducer;
